import { globalProps } from "neetocommons/initializers";

export const TIME_FORMAT = "h A";

export const DATE_FORMAT = globalProps.user?.dateFormat || "DD/MM/YYYY";
